interface DDNumberValueProps {
    listInputs: string[];
    label: string;
    inputName: string;
    value: number | null;
    handleOnChange(e: any): void;
    alwaysValid?: boolean;
  }
  
  function DDNumberValue({
    listInputs,
    label,
    value,
    handleOnChange,
    inputName,
    alwaysValid = false,
  }: DDNumberValueProps) {
    console.log(value);
    return (
      <div className="form-group">
        <label className="control-label">{label}</label>
        <select
          className={
            (value == null || value == -1) && !alwaysValid
              ? "form-control is-invalid"
              : "form-control "
          }
          name={inputName}
          value={value == null ? "-" : value}
          onChange={handleOnChange}
        >
          {listInputs.map((option, index) => (
            <>
              {option == "-" ? (
                <option key={index} value={-1}>
                  {option}
                </option>
              ) : (
                <option key={index} value={index}>
                  {option}
                </option>
              )}
            </>
          ))}
        </select>
      </div>
    );
  }
  export default DDNumberValue;
  